import { GENERATE_SHIPMENT_NUMBER } from "../actions/ShipmentNumber";

const initialState = {
  refreshShipmentNumber: false,
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case GENERATE_SHIPMENT_NUMBER:
      return {
        ...state,
        refreshShipmentNumber: action.payload,
      };
    default:
      return state;
  }
};
export default reducer;
